import { ContentPaste } from "@mui/icons-material";
import { IconButton, TableCell, Tooltip } from "@mui/material";

export function QuestionnairesActions({
  row,
  onOpenSelected,
}: {
  row: any;
  onOpenSelected: (row: any) => void;
}) {
  return (
    <TableCell align="center">
      <Tooltip title="Visualizar respostas">
        <IconButton
          onClick={() => {
            onOpenSelected(row);
          }}
        >
          <ContentPaste />
        </IconButton>
      </Tooltip>
    </TableCell>
  );
}
